// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@supports (font: -apple-system-body) and (-webkit-appearance: none) {\n    .tearsheetModal-modalWrapper-Gdh {\n        top: -2rem;\n        position: relative;\n    }\n}\n", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"modalWrapper": "tearsheetModal-modalWrapper-Gdh"
};
export default ___CSS_LOADER_EXPORT___;
